export function getChunkSize(): number {
	try {
		const envValue = Number((window as Window & { env?: { VITE_CHUNK_SIZE_MB?: unknown } }).env?.VITE_CHUNK_SIZE_MB);
		const chunkSize = envValue * 1024 * 1024;
		if (envValue >= 5 && Number.isSafeInteger(chunkSize)) return Math.min(chunkSize, MAX_CHUNK_SIZE);
	} catch {
		// Runtime configuration is untrusted; invalid coercions use the safe S3 minimum.
	}
	return MIN_CHUNK_SIZE;
}

export const MIN_CHUNK_SIZE = 5 * 1024 * 1024;
export const MAX_CHUNK_SIZE = 5120 * 1024 * 1024;
export const CHUNK_SIZE = getChunkSize();
